export const getArrCombinations = <T>(arr: T[], k: number): T[][] => {
    return arr.flatMap((current, idx) =>
        k > 1
            ? getArrCombinations(arr.slice(idx + 1), k - 1).map((other) => [
                  current,
                  ...other,
              ])
            : [[current]]
    );
};
